import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchClient } from '@/api/clients/clientsApi';
import type { Client } from '@/api/clients/clientsApi.types';
import { buildClientQueryKey } from '@/constants/queryKeys';

export function useClientQuery(clientId: string): UseQueryResult<Client, Error> {
  return useQuery({
    queryKey: buildClientQueryKey(clientId),
    queryFn: function loadClient() {
      return fetchClient(clientId);
    },
    enabled: clientId.length > 0,
  });
}
